export default __webpack_public_path__ + "static/media/secure_payment.ef343b01.svg";